import styled from 'styled-components'

// Utils
import { breakpoint } from 'utils'

// Components
import DismissableCard from 'components/DismissableCard'
import BackButton from 'modules/shares/components/BackButton'

export const StyledDismissableCard = styled(DismissableCard)`
  position: absolute;
  top: 20px;
  right: 20px;
  max-width: 314px;

  ${breakpoint('base', 'xs')`
  margin-left: 20px;
`}
`

export const Message = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.text.dark.primary};
  font-size: ${({ theme }) => theme.fontSizes.small};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  letter-spacing: ${({ theme }) => theme.letterSpacings[2]};
`

export const PageContent = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  display: flex;
  flex: 1 0 auto;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.background.light.secondary};

  backface-visibility: hidden;
  perspective: 1000;
  transition: all ${({ theme }) => theme.transitions.duration[3]};
  transition-property: width;
`

export const StyledBackButton = styled(BackButton)`
  position: absolute;
  top: 18px;
  left: 17px;
`
